import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const tabsTabFn = /* @__PURE__ */ createRecipe('tabs-tab', {
  "color": "neutral",
  "variant": "tab"
}, [
  {
    "variant": "pill",
    "color": "primary",
    "css": {
      "backgroundColor": "neutral.background.1.enabled",
      "color": "primary.foreground.2.enabled",
      "_hover": {
        "backgroundColor": "primary.background.4.hovered",
        "color": "primary.foreground.2.hovered"
      },
      "_active": {
        "backgroundColor": "primary.background.5.enabled",
        "color": "primary.foreground.2.enabled",
        "_hover": {
          "backgroundColor": "primary.background.2.hovered",
          "color": "neutral.foreground.1.onBrand.enabled"
        }
      }
    }
  },
  {
    "variant": "pill",
    "color": "neutral",
    "css": {
      "backgroundColor": "neutral.background.1.enabled",
      "color": "neutral.foreground.3.enabled",
      "_hover": {
        "backgroundColor": "neutral.background.2.hovered",
        "color": "neutral.foreground.2.hovered"
      },
      "_active": {
        "backgroundColor": "neutral.background.2.enabled",
        "color": "neutral.foreground.2.enabled",
        "_hover": {
          "backgroundColor": "neutral.background.3.hovered",
          "color": "neutral.foreground.2.hovered"
        }
      }
    }
  },
  {
    "variant": "tab",
    "color": "primary",
    "css": {
      "backgroundColor": "neutral.background.1.enabled",
      "color": "primary.foreground.2.enabled",
      "borderColor": "primary.stroke.3.enabled",
      "_hover": {
        "backgroundColor": "primary.background.4.hovered",
        "color": "primary.foreground.2.hovered",
        "borderColor": "primary.stroke.1.hovered"
      },
      "_active": {
        "backgroundColor": "primary.background.5.enabled",
        "color": "primary.foreground.2.enabled",
        "borderColor": "primary.stroke.2.enabled",
        "_hover": {
          "backgroundColor": "primary.background.2.hovered",
          "color": "neutral.foreground.1.onBrand.enabled",
          "borderColor": "primary.stroke.2.hovered"
        }
      }
    }
  },
  {
    "variant": "tab",
    "color": "neutral",
    "css": {
      "backgroundColor": "neutral.background.1.enabled",
      "color": "neutral.foreground.3.enabled",
      "borderColor": "neutral.stroke.3.enabled",
      "_hover": {
        "backgroundColor": "neutral.background.2.hovered",
        "color": "neutral.foreground.2.hovered",
        "borderColor": "neutral.stroke.1.hovered"
      },
      "_active": {
        "backgroundColor": "neutral.background.2.enabled",
        "color": "neutral.foreground.2.enabled",
        "borderColor": "neutral.stroke.2.enabled",
        "_hover": {
          "backgroundColor": "neutral.background.3.hovered",
          "color": "neutral.foreground.static.enabled",
          "borderColor": "neutral.stroke.2.hovered"
        }
      }
    }
  }
])

const tabsTabVariantMap = {
  "color": [
    "danger",
    "unstyled",
    "primary",
    "neutral"
  ],
  "variant": [
    "pill",
    "tab"
  ]
}

const tabsTabVariantKeys = Object.keys(tabsTabVariantMap)

export const tabsTab = /* @__PURE__ */ Object.assign(memo(tabsTabFn.recipeFn), {
  __recipe__: true,
  __name__: 'tabsTab',
  __getCompoundVariantCss__: tabsTabFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: tabsTabVariantKeys,
  variantMap: tabsTabVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, tabsTabVariantKeys)
  },
  getVariantProps: tabsTabFn.getVariantProps,
})